<ng-container *transloco="let t;">
<app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

  <div title>
    <h1>
      <span *ngIf="newMode()">{{ t('common.labels.order') }}</span>
      <span *ngIf="editMode()">{{ t('common.labels.order') }} <strong>{{ order.fullname }}</strong><br><i class="subline">{{ t('common.labels.status') }}: {{ t('common.toolbox_status.' + order.status) }}</i></span>
    </h1>
  </div>

  <div details>
    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

      <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
        <app-toolbox-candidate-new *ngIf="newMode()"></app-toolbox-candidate-new>
        <app-toolbox-candidate-basedata *ngIf="editMode()" [order]="order" (setEdit)="setEdit($event)"></app-toolbox-candidate-basedata>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.credentials') }}" leftIcon="pi pi-key" [disabled]="isDisabled('credentials') || order === null">
        <app-toolbox-candidate-credentials *ngIf="editMode()" [order]="order" (setEdit)="setEdit($event)"></app-toolbox-candidate-credentials>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.results') }}" leftIcon="pi pi-chart-bar" [disabled]="isDisabled('results') || order === null">
        <app-toolbox-candidate-results *ngIf="editMode()" [order]="order" (setEdit)="setEdit($event)" (updateOrder)="onUpdateOrder($event)"></app-toolbox-candidate-results>
      </p-tabPanel>

    </p-tabView>
  </div>

</app-detail-view>
</ng-container>
